<script>
import Layout from '@/Shared/Layout'
export default { layout: Layout }
</script>

<script setup>
import { onMounted } from 'vue'
import { Head } from '@inertiajs/inertia-vue3'
import usePref from '@/Shared/usePref.js'
import Pagenation from './Pagenation'

const props = defineProps({
  pref: Object,
})

onMounted(() => {
  usePref(props.pref)
})
</script>

<template>
  <div class="about history">
    <Head title="A&F40年の歴史を、創業者・赤津孝夫が振り返る。" />
    <div class="pb-[50px] sm:pt-[20px] overflow-x-hidden">
      <h2 class="page-title">
        History
        <small>A&amp;Fの歴史</small>
      </h2>
      <div class="m-auto px-[calc(5vw_+_10px)] xs:px-[40px] sm:px-[60px] lg:px-0 max-w-[500px] sm:max-w-[840px]">
        <Pagenation :page="2" />

        <div class="section">
          <div class="left"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img2_1.png" alt="" /></div>
          <div class="right">
            <h3>アウトドアというジャンルが<br />世の中に根付いてきた</h3>
            <p>Barbourの取扱を始めた頃ですね。もともとはアウトドアで使うものなのですが、日本人って街でも着ようとするから、最初はものすごく嫌われましたね。「他の洋服に匂いがつくから」って。まあ、今よりももっと匂いがきつかったですしベタベタしてましたからしょうがないですけど。本国からは「シークレットオイルだ」とか言われるんですけど、何がシークレットだかさっぱりわかりませんでしたね。今となっては良い思い出です。時代的にはアウトドアというジャンルが世の中に根付いてきた頃ですね。</p>
            <p>MAG-LITEは普通の懐中電灯が何百円という時代に何千円という値段でしたが、やはり機能が画期的でしたね。単純に他のものより明るかったということもありましたが、キャンドルの代わりになったり、焦点調節が利くとか、予備球が入っているとか、ボディ自体がアルミの削り出しで作られているとかいうふうに、道具としての要素が満載で面白かった。マニュアル本があったくらいですから。MAG-LITEを使って防御する方法とか、金網フェンスをよじ上るときはこれを差し込んで足場にしろとか。これも道具に対するこだわりと言うのでしょうか。</p>
          </div>
        </div>
        <div class="section">
          <div class="right"><img class="md:mt-[100px] md:ml-[50px] md:max-w-[160%]" src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img2_2.png" alt="" /></div>
          <div class="left md:!mr-[-20px]">
            <h3>日本人のものに対するこだわり<br />品質に対する見識の高さ</h3>
            <p>ファミリーキャンプという手軽なアウトドアライフスタイルが出始める一方で、カヤックをひとりで楽しむという方向性も出てきた頃。FEATHERCRAFTなどのカヤックの取扱を始めたのも90年代に入ってからです。まだ水を買うことがあたり前ではなかった頃、ミネラルウォーターの販売も一時やりました。</p>
            <p>GREGORYは、取扱を開始した1985年頃には、こんな高いものは売れないと思ってましたね。他社のデイパックが3千8百円とかで売られていた頃に2万円でしたから。大型パックは8万円だった。作りが丁寧だし、背負い心地も全然違うのはわかっているんだけど、いいものと売れるものとは違うんだよなという半信半疑な気持ちでしたね。ところがすぐに反応が出て売れ始めたんです。日本人のものに対するこだわりとか品質に対する見識には驚きましたね。アメリカの商品は荒っぽく作ってあるし、それが味だからって言われていた時代ですから。世界で最初にパックフィッティングという考え方を打ち出したのもGREGORYでした。「背負うのではなく着なさい」というキャッチフレーズがGREGORYの品質を物語っています。</p>
            <p>カタログの表紙をイラストにしたのは1988〜89年からですね。イラストレーター、ジャック・アンルーの水彩っぽいテイストが気に入ったのと、もともとアウトドアーズマンだから知識があるということで、「どこかへ行くときに描いてきてよ」みたいな感じで彼との付き合いが始まったんです。それ以来、彼にはずっと描いてもらっています。</p>
          </div>
        </div>
        <div class="section">
          <div class="left"><img src="https://img.aandf.co.jp/aandfcojp/img/corporate/about_img2_3.png" alt="" /></div>
          <div class="right">
            <h3>ファミリキャンプ全盛の時代<br />A&amp;Fウェブサイト開設</h3>
            <p>KAVUの取扱がこの頃。もともと社長が漁師でね。自分で漁船を操って、アラスカでサーモンを獲っていたんですよ。そのときに帽子が船上で飛んでいってしまうのが困るということで、ストラップで締められる帽子を考えたんですね。KAVUのキャップはものすごく売れました。</p>
            <p>ファミリーキャンプの流れのなかで、LODGEも定着してきた頃です。ダッチオーブンで料理を作るのが人気でレシピブックも何冊か作られました。JAPANDUTCHOVENSOCIETYというダッチオーブン好きのコミュニティも発足した時代でした。A&amp;Fウェブサイトが開設され、URLを掲載したのは98–99のカタログからですね。</p>
          </div>
        </div>

        <Pagenation :page="2" />
      </div>
    </div>
  </div>
</template>
